import styled from '@emotion/styled';

import IconButton from 'app/components/v2/components/IconButton';

const NavIconButton = styled(IconButton)(({
  theme,
}) => ({
  /* eslint-disable @typescript-eslint/naming-convention, sort-keys */
  backgroundColor: 'transparent',
  border: 'none',

  ['svg *']: {
    stroke: theme.semanticColors.text_inverted,
  },

  '&:hover': {
    backgroundColor: 'hsla(100, 100%, 0%, 20%)',
  },

  '&:active': {
    backgroundColor: 'hsla(100, 100%, 0%, 40%)',
  },
  /* eslint-enable @typescript-eslint/naming-convention, sort-keys */
}));

export default NavIconButton;
